import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    transferBatchesLoading: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Aria label for spinner while transfer batches are loading */
            transferBatchesLoading: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "UploaderSheet.transferBatchesLoading?c=26edfpfp52a7l", defaultMessage: "Transfer batches loading" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
